import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useOrganization } from '../contexts/OrganizationContext';
import { AppLoadingScreen } from './AppLoadingScreen';
import { logger } from '../utils/logger';

interface AppBootstrapProps {
  children: React.ReactNode;
}

export const AppBootstrap: React.FC<AppBootstrapProps> = ({ children }) => {
  const { currentUser, loading: authLoading } = useAuth();
  const { organization, loading: orgLoading } = useOrganization();
  const [isAppReady, setIsAppReady] = useState(false);

  useEffect(() => {
    const checkAppReadiness = () => {
      if (authLoading) {
        logger.debug('[AppBootstrap] Auth still loading...');
        setIsAppReady(false);
        return;
      }

      if (!currentUser) {
        logger.debug('[AppBootstrap] No user, app ready (public routes)');
        setIsAppReady(true);
        return;
      }

      if (currentUser.orgId && orgLoading) {
        logger.debug('[AppBootstrap] User has orgId, waiting for organization to load...');
        setIsAppReady(false);
        return;
      }

      logger.debug('[AppBootstrap] All core state resolved, app ready');
      setIsAppReady(true);
    };

    checkAppReadiness();
  }, [authLoading, currentUser, orgLoading, organization]);

  if (!isAppReady) {
    return <AppLoadingScreen />;
  }

  return <>{children}</>;
};
